import { createContext, ReactNode } from 'react'

interface IntercomProviderProps {
  children: ReactNode
}

export const IntercomContext = createContext({
  unreadMessagesCount: 0,
})

export const IntercomProvider = (props: IntercomProviderProps) => props.children
